// extracted by mini-css-extract-plugin
module.exports = {"archidekt":"Deck_archidekt__NUlaK","columns":"Deck_columns__PVSg8","cardColumn":"Deck_cardColumn__EqiJb"};